function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var TokenizedString = /*#__PURE__*/ function() {
    "use strict";
    function TokenizedString() {
        _class_call_check(this, TokenizedString);
    }
    _create_class(TokenizedString, null, [
        {
            key: "escapeRegExp",
            value: function escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }
        },
        {
            key: "findTokensBetweenDelimiters",
            value: // $& means the whole matched string
            function findTokensBetweenDelimiters(param) {
                var startDelimiter = param.startDelimiter, endDelimiter = param.endDelimiter, targetStr = param.targetStr;
                if (!startDelimiter || !endDelimiter || !targetStr) {
                    return;
                }
                var regex = new RegExp("".concat(this.escapeRegExp(startDelimiter), "(.*?)").concat(this.escapeRegExp(endDelimiter)), 'g');
                var matches = [];
                var match;
                while((match = regex.exec(targetStr)) !== null){
                    matches.push(match[1]);
                    // Reset lastIndex if delimiters are empty or same
                    if (startDelimiter === endDelimiter || startDelimiter === '' || endDelimiter === '') {
                        regex.lastIndex++;
                    }
                }
                return matches;
            }
        },
        {
            key: "replaceAll",
            value: function replaceAll(param) {
                var targetStr = param.targetStr, startDelimiter = param.startDelimiter, endDelimiter = param.endDelimiter, variable = param.variable, value = param.value;
                var intermediate = targetStr.replace("".concat(startDelimiter).concat(variable).concat(endDelimiter), value);
                var next = '';
                while(intermediate !== next){
                    // Linked List approach. Replacing variable in string until there is nothing left to replace
                    if (next) {
                        intermediate = next;
                    }
                    next = intermediate.replace("".concat(startDelimiter).concat(variable).concat(endDelimiter), value);
                }
                return next;
            }
        }
    ]);
    return TokenizedString;
}();

//# sourceMappingURL=tokenized-string.js.map